import Title from "./title.vue";
export default {
  install(app) {
    app.component("Title", Title);
    defineDirective(app);
  },
};

// 指令
const defineDirective = (app) => {
  // 图片懒加载指令
  // 原理：先存储图片地址不能放在src上，当图片进入可视区，将你存储的图片地址设置给图片元素即可
  app.directive("lazy", {
    mounted(el, binding) {
      // 创建一个对象，来观察当前指令的元素
      const observer = new IntersectionObserver(
        ([{ isIntersecting }]) => {
          if (isIntersecting) {
            //停止观察
            observer.unobserve(el);
            // 处理图片加载失败 error是图片加载失败的事件  load是图片加载成功的事件
            el.onerror = () => {
              alert("图片加载失败");
            };
            // 把指令的值设置给el的src属性 。binding.value就是指令的值
            el.src = binding.value;
          }
        },
        {
          threshold: 0.01,
        }
      );
      observer.observe(el);
    },
  });
};
